import { BookSpread } from '@graphql/generated/graphql';

export const findSpreadIndex = (array: BookSpread[], spreadId: string) =>
  array.findIndex((spr) => spr.id === spreadId);
